import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { StyledResponsiveBanner } from "./responsive-banner.scss";
const ResponsiveBanner = (props)=>{
    const { title, description, imageLink, titleTagComponent: TitleTag, descriptionTagComponent: DescriptionTag, color, isMobileBanner } = props;
    return /*#__PURE__*/ _jsxs(StyledResponsiveBanner, {
        className: classnames("responsive-banner-component", color, {
            "mobile-banner": isMobileBanner
        }),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "content-wrapper",
                children: [
                    /*#__PURE__*/ _jsxs(TitleTag, {
                        className: "title",
                        children: [
                            " ",
                            title,
                            " "
                        ]
                    }),
                    !isMobileBanner && /*#__PURE__*/ _jsxs(DescriptionTag, {
                        className: "description",
                        children: [
                            " ",
                            description
                        ]
                    })
                ]
            }),
            imageLink && /*#__PURE__*/ _jsx("div", {
                className: "image-wrapper",
                children: /*#__PURE__*/ _jsx("img", {
                    className: "banner-image",
                    src: imageLink
                })
            })
        ]
    });
};
export default ResponsiveBanner;
ResponsiveBanner.defaultProps = {
    titleTagComponent: "div",
    descriptionTagComponent: "div",
    color: "iris",
    isMobileBanner: false // not using isMobileOrTablet since we want this behaviour in every screen under 768px
};
